/* eslint-disable @next/next/no-img-element */
import Switch from "react-switch";
import { useEffect, useState } from "react";
import http from "../../../utilities/http";
import { isEmpty } from "lodash";
import { Loader } from "components/loader";

export default function Index({ }) {
    const [state, _setState] = useState({
        allowOthersViewArchiveBook: true,
        activeParentTab: 1,
        FAQChildList: [],
        FAQChildActive: "",
        supportCenter: [],
        policy: [],
        aboutUs: {},
        content: {},
        parentFocus: 0,
        active23: 0
    });
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        // switch (state.activeParentTab) {
        // case 1 :
        // if (state.FAQChildList.length === 0){
        const fetchFAQ = async () => {
            const faq = await http('community/faq', null, { token: '' }, 'v2');
            setState({ FAQChildList: faq?.data });
        };
        fetchFAQ();
        // }
        // case 4 :
        // if (isEmpty(state.aboutUs)){
        const fetchAboutUs = async () => {
            const res = await http('happynest/about', null, { token: '' }, 'v2');
            setState({ aboutUs: res?.data });
        };
        fetchAboutUs();
        // }

        // default :
        // if (state.parentFocus === 2){
        // if (state.policy.length === 0){
        const fetchPolicy = async () => {
            const res = await http('happynest/policy', null, { token: '' }, 'v2');
            setState({ policy: res?.data });
        };
        fetchPolicy();
        // }
        // } else if (state.parentFocus === 3){
        if (state.supportCenter.length === 0) {
            const fetchSupportCenter = async () => {
                const res = await http('happynest/support-center', null, { token: '' }, 'v2');
                setState({ supportCenter: res?.data });
            };
            fetchSupportCenter();
            // }
            // }
        }
        setLoading(false);
    }, []);

    const genListFAQ = state.FAQChildList?.map(x => {
        if (!x.content) return <></>;
        return (
            <li key={x?.id}>
                <h3 className="faq-title" data-toggle="collapse" data-target="#faq1" aria-expanded="false"
                    onClick={() => { setState({ FAQChildActive: state.FAQChildActive === x?.id ? "" : x?.id }); }}
                >{x?.title || ""}</h3>
                <div id="faq1" className={"faq-body collapse" + (x?.id === state.FAQChildActive ? "show" : "")} data-parent="#faq" dangerouslySetInnerHTML={{ __html: x?.content || '' }}>
                </div>
            </li>
        );
    });
    const switchProp = {
        onColor: "#34BEEF",
        height: 20,
        width: 48,
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.6)",
        activeBoxShadow: "0px 0px 1px 10px rgba(0, 0, 0, 0.2)",
        uncheckedIcon: false,
        checkedIcon: false,
        handleDiameter: 25
    };
    return (
        <div className="wrap p-0">
            <div className="wrap-support p-0">
                <div className="menubar">
                    <ul id="menu-bar" className="menubar-list">
                        {/*fpa*/}
                        <li onClick={() => {
                            setState({
                                activeParentTab: 1,
                                parentFocus: 0,
                                content: {},
                                active23: 0
                            });
                        }}>
                            <a style={{ cursor: "pointer" }} className={state.activeParentTab === 1 ? "active" : ""}><span className="icon">
                                <img className="svg" src="../images/support-faq.svg" alt="" /></span> FAQ
                            </a>
                        </li>
                        {/*policy*/}
                        <li>
                            <a style={{ cursor: "pointer" }} className={"hashsub " + (state.active23 === 2 ? "active" : "")} onClick={() => {
                                if (state.parentFocus !== 2) {
                                    setState({content: state.policy[0]});
                                }
                                setState({
                                    parentFocus: state.parentFocus === 2 ? 0 : 2,
                                    activeParentTab: 0,
                                });
                            }} data-toggle="collapse" data-target="#menu-sub1" aria-expanded="false"><span className="icon"><img className="svg" src="../images/support-policy.svg" alt="" /></span> Điều khoản chính sách</a>
                            <ul id="menu-sub1" className={"collapse submenu " + (state.parentFocus === 2 ? "show" : "")} data-parent="#menu-bar">
                                {state.policy.map((x, id) => {
                                    return <li key={id} onClick={() => {
                                        setState({
                                            content: x,
                                            parentFocus: 2,
                                            activeParentTab: 0
                                        });
                                    }}>
                                        <a className={x?.id === state.content?.id ? "active" : ""} style={{ cursor: "pointer" }}>{x?.title}</a>
                                    </li>;
                                })}
                            </ul>
                        </li>
                        {/*support*/}
                        <li>
                            <a style={{ cursor: "pointer" }} className={"hashsub " + (state.active23 === 3 ? "active" : "")} onClick={() => {
                                if(state.parentFocus !== 3) {
                                    setState({content: state.supportCenter[0]});
                                }
                                setState({
                                    parentFocus: state.parentFocus === 3 ? 0 : 3,
                                    activeParentTab: 0,
                                });
                            }} data-toggle="collapse" data-target="#menu-sub2" aria-expanded="false"><span className="icon"><img className="svg" src="../images/support-policy.svg" alt="" /></span> Trung tâm trợ giúp</a>
                            <ul id="menu-sub2" className={"collapse submenu " + (state.parentFocus === 3 ? "show" : "")} data-parent="#menu-bar">
                                {state.supportCenter?.map((x, id) => {
                                    return <li key={id} onClick={() => {
                                        setState({
                                            content: x,
                                            parentFocus: 3,
                                            activeParentTab: 0,
                                        });
                                    }}>
                                        <a className={x?.id === state.content?.id ? "active" : ""} style={{ cursor: "pointer" }}>{x?.title}</a>
                                    </li>;
                                })}
                            </ul>
                        </li>
                        {/*about us*/}
                        <li onClick={() => {
                            setState({
                                activeParentTab: 4,
                                parentFocus: 0,
                                content: {},
                                active23: 0
                            });
                        }}>
                            <a style={{ cursor: "pointer" }} className={state.activeParentTab === 4 ? "active" : ""}><span className="icon">
                                <img className="svg" src="/images/support-policy.svg" alt=""/></span> Giới thiệu Happynest
                            </a>
                        </li>
                    </ul>
                    <div className="setting-view-save">
                        <span className="text">Cho phép người khác xem Sổ lưu trữ</span>
                        <div className="switch switch--notif">
                            <label className="switch-label">
                                <input className="switch-checkbox" checked="" value="on" type="checkbox" />
                                <Switch {...switchProp} onChange={() => { setState({ allowOthersViewArchiveBook: !state.allowOthersViewArchiveBook }); }} checked={state.allowOthersViewArchiveBook} />
                            </label>
                        </div>
                    </div>
                </div>
                <div className="support-content">
                    {!isEmpty(state.content) &&
                        <div className="groupCategory-title">
                            <h3 style={{ fontWeight: "500", fontSize: "18px", paddingBottom: "20px" }}>{state.content.title}</h3>
                            <div id="faq1" className={"faq-body"} dangerouslySetInnerHTML={{ __html: state.content.content || state.content.description || '' }}>
                            </div>
                        </div>
                    }
                    {state.activeParentTab === 1 &&
                        <ul id="faq" className="faq-list">
                            {genListFAQ}
                        </ul>
                    }
                    {state.activeParentTab === 4 &&
                        <div className="groupCategory-title">
                            <h3 style={{ fontWeight: "500", fontSize: "18px", paddingBottom: "20px" }}>{state.aboutUs.title}</h3>
                            <div id="faq1" className={"faq-body"} dangerouslySetInnerHTML={{ __html: state.aboutUs.content || '' }}>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}